import { hesselViewModels } from '../../../lib/view-models';
import { InnerCarouselItem } from './carousel.types';

export function mapSlides(slides: hesselViewModels.PdpResource[], carouselId: string): InnerCarouselItem[] {
    return slides.map((slide, i) => ({
        id: `${carouselId}-${i}`,
        slide,
    }));
}
